import React from "react";
import styles from "./styles.module.scss";
import { TextBody1 } from "fonts/Body1";

export interface IRadioButtonProps {
  checked?: boolean;
  label?: string;
  name?: string;
  value: string | number;
  id: string | undefined;
  onClick: () => void;
}

export const RadioButton = ({
  checked,
  label,
  name,
  onClick,
  ...rest
}: IRadioButtonProps) => (
  <div className={styles.root} onClick={onClick}>
    <input type="radio" checked={checked} {...rest} />
    {label && (
      <label htmlFor={name}>
        <TextBody1>{label}</TextBody1>
      </label>
    )}
  </div>
);
